import { render, staticRenderFns } from "./d2-container-ghost.vue?vue&type=template&id=41660bd9&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports